import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-blush-light text-navy pt-20 pb-8 relative overflow-hidden rounded-t-[3rem] mt-12 border-t border-blush" data-id="element-30">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-31">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-pink-soft rounded-full mix-blend-multiply filter blur-3xl opacity-50" data-id="element-32"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-peach-light rounded-full mix-blend-multiply filter blur-3xl opacity-50" data-id="element-33"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-34">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-35">
          <div className="col-span-1 md:col-span-2" data-id="element-36">
            <h3 className="font-serif text-2xl mb-4 flex items-center gap-2" data-id="element-37">
              Programme Liberty <span className="text-rosegold" data-id="element-38">✨</span>
            </h3>
            <p className="text-navy/70 text-sm leading-relaxed max-w-md mb-6" data-id="element-39">
              Devenez la bâtisseuse de votre propre liberté. Que ce soit par la
              création de votre empire cosmétique ou par l'investissement
              stratégique.
            </p>
            <div className="flex gap-4" data-id="element-40">
              <a href="https://www.instagram.com/martesbeautyswiss/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-rosegold hover:bg-rosegold hover:text-white transition-all shadow-sm" data-id="element-41">
                <InstagramIcon className="w-5 h-5" data-id="element-42" />
              </a>
              <a href="https://www.tiktok.com/@martes.swiss" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-rosegold hover:bg-rosegold hover:text-white transition-all shadow-sm" data-id="element-43">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-44">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-45" />
                </svg>
              </a>
            </div>
          </div>

          <div data-id="element-46">
            <h4 className="font-serif text-lg mb-4 text-rosegold" data-id="element-47">
              Programmes
            </h4>
            <ul className="space-y-3" data-id="element-48">
              <li data-id="element-49">
                <Link to="/cosmetic-empire" className="text-sm text-navy/70 hover:text-rosegold transition-colors" data-id="element-50">
                  Cosmetic Empire Academy
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/programme-liberty" className="text-sm text-navy/70 hover:text-rosegold transition-colors" data-id="element-52">
                  Real Estate & Mindset
                </Link>
              </li>
              <li data-id="element-53">
                <a href="https://martesbeauty.com" target="_blank" rel="noopener noreferrer" className="text-sm text-navy/70 hover:text-rosegold transition-colors" data-id="element-54">
                  Boutique Martes Beauty
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-55">
            <h4 className="font-serif text-lg mb-4 text-rosegold" data-id="element-56">
              Partenaires
            </h4>
            <ul className="space-y-3" data-id="element-57">
              <li className="text-sm text-navy/70" data-id="element-58">Shopify Partner</li>
              <li className="text-sm text-navy/70" data-id="element-59">Revolut Business</li>
              <li className="text-sm text-navy/70 mt-4 pt-4 border-t border-rosegold/20" data-id="element-60">
                En partenariat avec une agence marketing experte pour la
                technique.
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-rosegold/20 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-61">
          <p className="text-xs text-navy/50" data-id="element-62">
            © {new Date().getFullYear()} Programme Liberty. Tous droits
            réservés.
          </p>
          <div className="flex gap-6" data-id="element-63">
            <a href="#" className="text-xs text-navy/50 hover:text-rosegold transition-colors" data-id="element-64">
              Mentions Légales
            </a>
            <a href="#" className="text-xs text-navy/50 hover:text-rosegold transition-colors" data-id="element-65">
              Politique de Confidentialité
            </a>
            <a href="#" className="text-xs text-navy/50 hover:text-rosegold transition-colors" data-id="element-66">
              CGV
            </a>
          </div>
        </div>
      </div>
    </footer>;
}